import request from "@/utils/request";

export function getFollowingBrands() {
  return request({
    url: "/product/brand/collect/list",
    method: "get",
  });
}
